import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { ModalTitle } from "../uikit/Modal/styled";
import Modal from "../uikit/Modal";
import { ActionButton } from "../uikit";
import { Text} from "./styled";


export const CallPermissionRequired: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [open, setOpen] = React.useState(true)

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalTitle>Your call attempt using the Dasha.AI telephony service has been denied due to insufficient permissions.</ModalTitle>

      <Text style={{ marginTop: 8 }}>
        <p>To request permission to make calls using our telephony, please book a meeting using <Link target="_blank" to="https://calendly.com/vlad-chernyshov/45-minute-meeting-broad">this link</Link> or contact us at support@dasha.ai. We’ll guide you through the process and answer any questions you may have.</p>
        <p>Alternatively, you can use your own telephony (see our <Link target="_blank" to="https://docs.dasha.ai/en-us/default/tutorials/sip-outbound-calls/">docs</Link>).</p>
      </Text>

      <div style={{ display: "flex", marginTop: 16 }}>
        <ActionButton style={{ flex: 1 }} onClick={onClose}>
          I UNDERSTAND
        </ActionButton>
      </div>
    </Modal>
  )
}
